interface FAQItemType {
  question: string;
  answer: string;
}



export const questions: FAQItemType[] = [
  {
    question: "What sets Slick Slicer apart from other resin slicers?",
    answer: "Slick Slicer is a modern, lightweight solution built with the Rust programming language. Its GPU-accelerated architecture is designed to make preparing resin prints faster and more responsive."
  },
  {
    question: "Can I test Slick Slicer before making a purchase?",
    answer: "A free demo is planned. Slick Slicer is still in development; access details will be shared when the demo is ready."
  },
  {
    question: "What licensing models are available?",
    answer: "We offer an individual version and a dedicated business version. We are also open to fully customizing and tailoring Slick Slicer to meet the specific needs of individual companies through our enterprise solutions."
  },
  {
    question: "Where can I follow the development progress of the project?",
    answer: "Slick Slicer is currently under active development. Contact us at support@slick-slicer.com to ask about progress and upcoming availability."
  },
  {
    question: "Will Slick Slicer include advanced editing features?",
    answer: "Our philosophy is to provide a lightweight and high-speed tool. Slick Slicer will be systematically expanded with new, modern, and more advanced features added in subsequent phases of the software's development."
  },
  {
    question: "Why did you choose to build the slicer using Rust?",
    answer: "Rust is a modern programming language that combines C++-like performance with top-tier memory safety. Its performance and memory safety make it a strong foundation for handling complex 3D models and building a reliable slicing workflow."
  },
];
